const baseResponse = {
    type: "OK",
    data: {
        paginator: {
            page: 1,
            has_previous: false,
            has_next: false,
            total_pages: 1,
            total_results: 3
        },
        time: {
            statsForDate: '24.10.2020', // на какое число статистика
            nextStatsUpdate: '01.11.2020', // когда следующее обновление статистики
        },
        // ... специализированные данные
    },
}

function responseTest(origin, object) {
    Object.keys(origin).forEach(key => {
        if (!has(key)) console.error('Ответ не содержит поля: ' + key)
        if (!typeAgreement(key)) console.error('В ответе тип поля не соответсвует контракту: ' + key)

        if (typeof origin[key] === 'object' && origin[key] !== null) {
            responseTest(origin[key], object[key])
        }
    })

    function has(key) {
        return object[key]
    }

    function typeAgreement(key) {
        return typeof origin[key] === typeof object[key]
    }
}



export function handleResponse(response) {
    const result = response.data.result
    if (typeof result === 'undefined') {
        throw new Error('Результат выполнения операции неизвестен. Сервер ответил с ошибкой.')
    }
    if (typeof result !== 'object') {
        throw new Error('Результат пришёл в неверном формате и не может быть обработан.')
    }

    const statuses_map = response.data.statuses_map

    const entries = Object.entries(result)
    entries.forEach(entry => {
        entry[1] = statuses_map[entry[1]]
    })

    return entries
}